import { render } from "./dashboard-options.vue?vue&type=template&id=6aab5d0c&ts=true"
import script from "./dashboard-options.vue?vue&type=script&lang=ts"
export * from "./dashboard-options.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__